import { Oval } from 'react-loader-spinner';

export const SmallSpinner = () => {
  return (
    <div className="d-inline-flex align-items-center justify-items-center">
      <Oval color="#fff" width={20} height={20} strokeWidth={6} />
    </div>
  );
};
